import { render } from "./EditNotes.vue?vue&type=template&id=adc47210"
import script from "./EditNotes.vue?vue&type=script&lang=js"
export * from "./EditNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__